<script>
export default {
  name: "VMarkdown",
  props: {
    data: {
      type: String,
      default: null
    }
  }
};
</script>

<template>
  <div v-html="data" class="markdown" />
</template>
